import { inventories } from "@/api/inventories/useInventoriesQuery";
import {
  NoDataTr,
  PaginationWrapper,
  TabBodyTable,
  TabBodyTitle,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  WorkTabBodyContainer,
} from "@/features/work/WorkView/WorkProductionHistory";
import { setDateFormatStringWithTime } from "@/utils/dateTimeUtil";
import { setToLocaleString } from "@/utils/unitMark";
import { Checkbox, Pagination, Text } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useTranslation } from "react-i18next";
interface WorkProductionInventoryProps {
  lstItemCode: (string | undefined)[];
  locationCode?: string;
}

export const WorkProductionInventory = ({
  lstItemCode,
  locationCode,
}: WorkProductionInventoryProps) => {
  const [activePage, setActivePage] = useState<number>(1);
  const { t } = useTranslation();

  // TODO: 데이터 바뀌면 재적용 필요
  // const { data: productionInventory } = useInventoriesGetQuery({
  //     query: {
  //         $and: [
  //             { itemCode: lstItemCode },
  //             { locationCode: locationCode },
  //             { quantity: { $ne: 0 }},
  //         ],
  //     },
  //     activePage: activePage,
  // });
  const { data: productionInventory } = useQuery(
    inventories.get({
      query: {
        $and: [{ itemCode: lstItemCode }, { locationCode: locationCode }, { quantity: { $ne: 0 } }],
      },
      page: activePage,
    }),
  );

  const rows: any[] = productionInventory?.data?.rows ?? [];

  return (
    <WorkTabBodyContainer>
      <TabBodyTitle>
        <Text fz="xl" fw={500}>
          {t("workTab.productionInventory")}
        </Text>
        <Text fz="xs" fw={400}>
          {t("productionInventory.description")}
        </Text>
      </TabBodyTitle>
      <TabBodyTable>
        <Thead>
          <Tr>
            <Th width={100}>{t("routing.sequence")}</Th>
            <Th width={180}>{t("inputLot.material")}</Th>
            <Th width={200}>{t("inputLot.materialLot")}</Th>
            <Th width={200}>{t("inputLot.inputLot")}</Th>
            <Th width={200}>{t("inputLot.createdAt")}</Th>
            <Th>{t("inventory.quantity")}</Th>
          </Tr>
        </Thead>
        <Tbody>
          {rows.length ? (
            rows.map((inputLot) => (
              <Tr>
                <Td width={100} style={{ justifyContent: "flex-end" }}>
                  {inputLot.id}
                </Td>
                {/* TODO: mantine UI -> NavLink 적용 필요 */}
                <Td width={180}>{inputLot.lotName}</Td>
                <Td width={200}>
                  <Checkbox
                    size="xs"
                    mr={12}
                    label={t("lot.name")}
                    defaultChecked={inputLot.itemUsesLotName}
                    disabled
                  />
                  <Checkbox
                    size="xs"
                    label={t("lot.expiration")}
                    defaultChecked={inputLot.itemUsesLotExpiration}
                    disabled
                  />
                </Td>
                <Td width={200}>[LOT] id: {inputLot.lotId}</Td>
                <Td width={200}>{setDateFormatStringWithTime(inputLot.lotCreatedAt)}</Td>
                <Td style={{ justifyContent: "flex-end" }}>
                  {setToLocaleString(inputLot.quantity)} {inputLot?.unitText}
                </Td>
              </Tr>
            ))
          ) : (
            <NoDataTr>
              <Text>{t("productionInventory.notFound")}</Text>
            </NoDataTr>
          )}
        </Tbody>
      </TabBodyTable>
      <PaginationWrapper>
        <Pagination
          onChange={setActivePage}
          value={activePage}
          total={productionInventory?.data?.totalPages ?? 0}
          size="lg"
          radius="sm"
        />
      </PaginationWrapper>
    </WorkTabBodyContainer>
  );
};
